<template>
  <div class="setting">
    <van-nav-bar
      title="更换手机号"
      left-text=""
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="cell-group">
      <div>
        <!-- <img src="../../assets/images/setting/phone.png" class="phone-img" /> -->
        <p
          class=""
          style="
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: 500;
            color: #2e4344;
          "
        >
          当前手机号
        </p>
        <p
          class="p16"
          style="
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #191b1e;
            margin-bottom: 20px;
          "
        >
          {{
            oldPhone &&
            oldPhone.substring(0, 3) +
              "****" +
              oldPhone.substring(7, oldPhone.length)
          }}
        </p>
      </div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="newPhone"
          name="phone"
          placeholder="请输入新手机号"
          type="tel"
          maxlength="11"
          style="margin-bottom: 25px"
        />
        <van-field
          v-model="smsCode"
          name="smsCode"
          center
          clearable
          label=""
          type="number"
          placeholder="请输入验证码"
          class="smsCode-input"
          maxlength="6"
        >
          <template #button>
            <input
              readonly
              class="push-btn"
              @click="sendCode"
              :disabled="btnStatus"
              :value="
                verifyCode == '获取验证码' ? verifyCode : verifyCode + 's'
              "
            />
          </template>
        </van-field>

        <div class="setting_logout">
          <van-button round block type="info" native-type="submit">
            确定
          </van-button>
        </div>
        <p class="p14">换绑后，请重新登录</p>
      </van-form>
    </div>
  </div>
</template>
<script>
import { validateMobile, validatePassword } from "../../common/validate";
import { _getCode, _getCheckCode } from "../../api/login";
import { _changePhone } from "../../api/setting";
import Cookies from "js-cookie";
import { verticalScreen } from "../../assets/js/vertical-screen";
import { encryptBy, decryptBy } from "@/assets/js/encryption";

export default {
  name: "replace-phone",
  data() {
    return {
      oldPhone: "18043092678", //旧手机号
      newPhone: "", //新手机号
      smsCode: "", //验证码
      btnStatus: false, // 是否可以点击
      verifyCode: "获取验证码", // 获取验证码 倒计时
      timer: null, // 倒计时
    };
  },
  created() {
    // this.oldPhone = JSON.parse(localStorage.getItem('userInfo')).mobilePhone
    let info = localStorage.getItem("userInfo");
    let user = JSON.parse(decryptBy(info));
    this.oldPhone = decryptBy(user.mobilePhone);
  },
  mounted() {
    verticalScreen();
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    //发送验证码
    sendCode() {
      if (!this.newPhone) {
        this.$toast("请输入手机号");
        return false;
      } else if (!validateMobile(this.newPhone)) {
        this.$toast("手机号码格式不正确，请重新输入");
        return false;
      }
      _getCode({
        origin: "C",
        phone: encryptBy(this.newPhone),
        type: 3,
      }).then((res) => {
        if (res.code == 200) {
          this.verifyCode = 120;
          this.btnStatus = true;
          this.timer = setInterval(() => {
            if (this.verifyCode > 0 && this.verifyCode <= 120) {
              this.verifyCode = this.verifyCode - 1;
            } else {
              clearInterval(this.timer);
              this.verifyCode = "获取验证码";
              this.btnStatus = false;
            }
          }, 1000);
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 校验验证码
    getCheckCode() {
      _getCheckCode({
        phone: encryptBy(this.newPhone),
        code: this.smsCode,
        origin: "C",
      }).then((res) => {
        if (res.code && res.code == 200) {
          if (res.data) {
            this.changePhone();
          } else {
            this.$toast(res.message);
          }
        } else {
          this.$toast(res.message);
          return false;
        }
      });
    },
    // 修改手机号
    changePhone() {
      if (!this.newPhone) {
        this.$toast("请输入新手机号");
        return false;
      }
      _changePhone({
        newPhone: encryptBy(this.newPhone),
        oldPhone: encryptBy(this.oldPhone),
        origin: "C",
      }).then((res) => {
        if (res.code == 200) {
          this.$toast("修改成功，请重新登录");
          Cookies.remove("token");
          localStorage.removeItem("childId");
          localStorage.removeItem("children");
          this.$router.push("/login");
        } else {
          this.$toast(res.message);
        }
      });
    },
    //提交
    onSubmit() {
      if (!this.newPhone) {
        this.$toast("请输入手机号");
        return false;
      } else if (!validateMobile(this.newPhone)) {
        this.$toast("手机号码格式不正确，请重新输入");
        return false;
      }
      this.getCheckCode();
    },
  },
};
</script>
<style lang="less" scoped>
.setting {
  position: relative;
  .cell-group {
    background: url(../../assets/images/setting/bg.png) no-repeat left top/100%
      211px;
  }
  .van-cell {
    padding: 11px 20px !important;
  }

  .smsCode-input {
    padding: 13px 0 12px;
  }
  .cell-group {
    padding: 20px;
    /deep/.van-cell {
      padding: 15px 0;
      line-height: 20px;
      font-size: 14px;
      box-sizing: border-box;
      border-bottom: 1px solid #eaeaea;
      .van-field__label {
        width: 39px;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        border-right: 1px solid #999999;
      }
      .push-btn {
        background: transparent;
        width: 110px;
        // height: 25px;
        // background: #FFF6F1;
        // border-radius: 13px;
        // border: 1px solid #FF8340;
        font-size: 14px;
        font-weight: 400;
        color: #00aadf;
        padding: 0;
        opacity: 1;
        -webkit-appearance: none;
        outline: none;
        text-align: right;
      }
    }
    .phone-img {
      width: 87px;
      height: 127px;
      margin-top: 20px;
    }
    .margin-p {
      margin: 18px;
    }
    .p14 {
      margin-top: 14px;
      text-align: center;
      color: #949c9d;
    }
  }
  .filedimg {
    width: 18px;
    height: 8px;
  }
  ::v-deep .van-icon {
    color: #000;
  }
  /deep/ .setting_logout {
    margin-top: 35px;
    text-align: center;
    .van-button--info {
      margin: 0 auto;
      width: 315px;
      height: 44px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      line-height: 44px;
      border: none;
    }
  }
}
</style>
